import SchoolNavigation from './SchoolNavigation';

export default SchoolNavigation;
